import React, { useEffect, useState } from 'react';
import PageHeading from '../components/page_heading/PageHeading';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { Block, BlockHead, BlockHeadContent, BlockTitle, PreviewCard, Row } from '../../../components/Component';
import { useSelector } from 'react-redux';
import { weigh_bridge_ticket_index_data } from './warehouse_data/warehouse_management_data';
import { CardLinkInfo } from '../components/cards/CardLinks';
import * as app_consts from "../../../constants/react_app_consts";
import { retrieve_actions_from_one_object } from '../../../utils/Utils';

const WeighBridgeTicketIndex = () => {

    const [page_data, setPageData] = useState([]);
    const [componentData, setComponentData] = useState([]);

    // Retrieve Module Actions Data
    const action_roles = useSelector((state) => state.auth_routes.auth_routes);
    // UseEffect to Place Page Data
    useEffect(() => {
        if (action_roles.status === app_consts.SUCCESS)
        {
            setPageData(action_roles.data);
        }
    }, [action_roles]);

    // UseEffect to Listen to Page Data
    useEffect(() => {
        if (page_data.length !== 0)
        {
            setComponentData(retrieve_actions_from_one_object(page_data, weigh_bridge_ticket_index_data));
        }
    }, [page_data]);

    // Funtion to Open User Search Module
    const open_search_module = (search_module_data) => {
    };

    return (
        <>
            <Head title='Warehouse Management' />
            <Content>
                <PageHeading title="Weigh Bridge Tickets" description="View, Create and Finish Processing Weigh Bridge Tickets" />
                <Block size="lg">
                    <PreviewCard>
                        <BlockHead>
                            <BlockHeadContent className="text-center">
                                <BlockTitle tag="h4">Select an Option</BlockTitle>
                                <p>View Weigh Bridge Tickets, Create Weigh Bridge Tickets and FInish Processing Weigh Bridge Tickets.</p>
                            </BlockHeadContent>
                        </BlockHead>
                        <Row className="g-gs flex mb-2">
                            {componentData &&
                                componentData?.map((comp_data) => {
                                    return (
                                        <CardLinkInfo
                                            key={comp_data.module_action_id[0]}
                                            colSize="4"
                                            iconType={comp_data.module_iconType}
                                            icon={comp_data.module_icon}
                                            cardTitle={comp_data.module_title}
                                            cardTextInfo={comp_data.module_description}
                                            buttonLink={comp_data.module_buttonLink}
                                            buttonText={comp_data.module_buttonText}
                                            comp_data={comp_data}
                                            buttonType={comp_data.module_button_type}
                                            buttonModuleFunction={comp_data.module_button_type === app_consts.BUTTON_OPEN_MODAL_TYPE ? open_search_module : ""}
                                        />
                                    );
                                })
                            }
                        </Row>
                    </PreviewCard>
                </Block>
            </Content>
        </>
    );
};

export default WeighBridgeTicketIndex;